<template>
  <div popup>
    <div class="dim"></div>
    <div class="holder">
      <slot/>
    </div>
  </div>
</template>

<style lang="less" scoped>
 @import "../../less/proj";

  [popup] { z-index: 999; .abs; .lt; width:100%;
    .dim { .fix; .lt; width:100%; height:120%; background: rgba(0,0,0,0.6); z-index: 50; }
    .holder { .abs; .lt; z-index: 51; width: 100%;}
  }
</style>

<script>
import { getScrollBody, getOffsetTop } from '../../utils';

export default {
  name: 'Popup',
  mounted() {
    const holder = this.$el.querySelector('.holder');
    holder.style.top = `${getScrollBody().scrollTop - getOffsetTop(this.$el)}px`;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/Popup.vue